/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Org_Switcher_Add_DescriptionInputs */



/**
* | output |
* | --- |
* | "Sign in with your account in the other organization. You stay signed in to your current organizations and can switch between them in this menu." |
*
* @param {Org_Switcher_Add_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const org_switcher_add_description = /** @type {((inputs?: Org_Switcher_Add_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Org_Switcher_Add_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Melde dich mit deinem Konto der anderen Organisation an. Du bleibst in deinen bisherigen Organisationen angemeldet und kannst in diesem Menü zwischen ihnen wechseln.")
	return /** @type {LocalizedString} */ ("Sign in with your account in the other organization. You stay signed in to your current organizations and can switch between them in this menu.")
});